import { render, staticRenderFns } from "./FilterDelivery.vue?vue&type=template&id=a72cf3d4&scoped=true"
import script from "./FilterDelivery.vue?vue&type=script&lang=ts"
export * from "./FilterDelivery.vue?vue&type=script&lang=ts"
import style0 from "./FilterDelivery.vue?vue&type=style&index=0&id=a72cf3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72cf3d4",
  null
  
)

export default component.exports